import React, { FC, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {TFunction} from 'i18next';

import NavArrowLnk from '~src/shared/buttons/NavArrowLnk';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import { HeaderContainer } from '~src/modules/surveys/components/schedules/scheduleItem/templates/scheduleTemplate.sc';
import { IconMargin, Header } from '~src/modules/surveys/components/topic_select/edit/topicQuestionsForm.sc';

interface Props extends Pick<RouteComponentProps<object>, 'history'> {
  t: TFunction;
  surveyId: string;
  isNewSurvey: boolean;
  showSave: boolean;
  selectedQuestions: Record<string, Record<string, boolean>>;
  isPrivate?: boolean;
}

const ContainerHeader: FC<Props> = React.memo(
  ({ selectedQuestions, t, surveyId, showSave, isNewSurvey, isPrivate, history }) => {
    const [isSelected, setIsSelected] = useState(false);
    useEffect(() => {
      if (selectedQuestions) {
        setIsSelected(false);
        for (const topic of Object.values(selectedQuestions)) {
          for (const question of Object.values(topic)) {
            if (question) {
              setIsSelected(true);
              break;
            }
          }
        }
      }
    }, [selectedQuestions]);

    function goToSummary() {
      history.replace(`/content/surveys/${surveyId}/summary`);
    }

    const questionSelectedKey = isSelected ? 'question_selected' : 'empty';
    const backArrowTxtKey = `x.surveys.detail.info.back${!showSave ? '.pristine' : ''}`;
    return (
      <Header $isPrivate={isPrivate}>
        <HeaderContainer data-translation={`x.surveys.details.select_question.header.${questionSelectedKey}`}>
          {t(`x.surveys.details.select_question.header.${questionSelectedKey}`)}
          <IconMargin>
            <HoverInfoIcon
              infoText={{
                key: 'x.surveys.detail.header.info_box',
                txt: t('x.surveys.detail.header.info_box'),
              }}
            />
          </IconMargin>
        </HeaderContainer>
        {!isNewSurvey && (
          <div onClick={goToSummary}>
            <NavArrowLnk data-translation={backArrowTxtKey}>{t(backArrowTxtKey)}</NavArrowLnk>
          </div>
        )}
      </Header>
    );
  },
);

export default ContainerHeader;
